import axios from '../Api/api';

export default function faq() {
    return new Promise((resolve, reject) => {
        axios.get("home/getFaq", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
